import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import {
  GetCircle,
  GetCirclebyID,
  GetDataByWardId,
  GetWard,
  GetWardsbyCircleId,
  GetZone,
} from "../../Apis/organizationApi";
import { useForm } from "react-hook-form";
//import { GoogleMap, LoadScript, MarkerF, Circle, useLoadScript } from "@react-google-maps/api";
import {
  createTransferStationMaster,
  getAllTransferStationMaster,
  getTransferStationById,
  updateTransferStationMaster,
} from "../../Apis/transferStationApi";
import { FILE_BASE_URL } from "../../Services/baseApiUrl";
import { useNavigate } from "react-router-dom";
import ImageCompressor from "image-compressor.js";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
import {
  MapContainer,
  TileLayer,
  Marker,
  Circle,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { handleAlphaNumeric } from "../../../utils/ValidationsHelper";
//import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";

import { CorporationStore } from "../corporation_master/CorporationStore";
import TableSkeleton from "../AllotedMaster/TableSkeleton";

const TransferStationMaster = ({ t }) => {
  const navigate = useNavigate();
  const libraries = ["places"];
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
    const { fetchCorporationDetails, CorporationDetails } = CorporationStore();
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const center = {
    lat: 17.452555,
    lng: 78.3599819,
  };
  const headers = [
    "transferStationCode",
    "transferStation",
    "transferStationAddress",
    // "numberOfContainers",
    // "approximateTravelTimeInMinutes",
    "transferStationCapacity",
    "corporation",
    "zone",
    "circle",
    "ward",
    "latitude",
    "longitude",
    "status",
    "actions",
  ];
  const [transferStationData, setTransferStationData] = useState([]);
  const [editTransferStationData, setEditTransferStationData] = useState("");
  // const [testLat, setTestLat] = useState(78.3599819);
  const [formInput, setFormInput] = useState({
    transferStationName: "",
    transferStationCode: "",
    transferStationLocation: "",
    transferStationCapacity: "",
    numberOfContainers: "",
    approximateTravelTimeInMinutes: null,
    Remarks:"",
    radiusInMeters: null,
    longitude: center.lat,
    latitude: center.lng,
    corporationId: "",
    zoneId: "",
    circleId: "",
    wardId: null,
    isActive: true,
    transferStationId: "",
  });
  const [allZones, setAllZones] = useState([]);
  const [noWardsUnderCircle, setNoWardsUnderCircle] = useState(false);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [selectedWard, setSelectedWard] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [noCircles, setNoCircles] = useState(false);
  const [editTransferStationId, setEditTransferStationId] = useState(null);
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [loadingWards, setLoadingWards] = useState(false);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedTransferStation, setSelectedTransferStation] = useState(null);
  const [wards, setWards] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [circles, setCircles] = useState([]);
  const [allZonesData, setAllZonesData] = useState([]);
  const [allCirclesData, setAllCirclesData] = useState([]);
  const [allWardsData, setAllWardsData] = useState([]);
  const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
  const [
    selectedTransferStationCoordinates,
    setSelectedTransferStationCoordinates,
  ] = useState(center);
  const [radiusInMeters, setRadiusInMeters] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [
    filterOriginalTransferStationData,
    setFilterOriginalTransferStationData,
  ] = useState([]);
  const resetRef = useRef(null);
  const isFetchingInitialDataRef = useRef(false);
  const initialDataPromiseRef = useRef(null);
  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: "AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw",
  //   libraries,
  // });
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(()=>{fetchCorporationDetails()},[])

  const fetchInitialData = async () => {
    try {
      // If already fetching, return the existing promise (prevents duplicate calls)
      if (isFetchingInitialDataRef.current && initialDataPromiseRef.current) {
        return await initialDataPromiseRef.current;
      }
      
      // If data is already loaded, return it immediately (prevents duplicate calls)
      if (isInitialDataLoaded && allZonesData.length > 0) {
        return {
          zones: allZonesData,
          circles: allCirclesData,
          wards: allWardsData,
        };
      }
      
      // Mark as fetching and create a promise
      isFetchingInitialDataRef.current = true;
      initialDataPromiseRef.current = (async () => {
        setIsOptionsLoading(true);
        // Fetch zone, circle, and ward reference data once
        const [zoneResponse, circleResponse, wardResponse] = await Promise.all([
          GetZone(),
          GetCircle(),
          GetWard(),
        ]);
      
        setAllZonesData(zoneResponse);
        setAllCirclesData(circleResponse);
        setAllWardsData(wardResponse);

        const zoneTrueValues = zoneResponse.filter(
          (item) => item.isActive === true
        );
        setAllZones(zoneTrueValues);
        
        setIsInitialDataLoaded(true);
        setIsOptionsLoading(false);
        isFetchingInitialDataRef.current = false;
        initialDataPromiseRef.current = null;
        
        return {
          zones: zoneResponse,
          circles: circleResponse,
          wards: wardResponse,
        };
      })();
      
      return await initialDataPromiseRef.current;
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setIsOptionsLoading(false);
      isFetchingInitialDataRef.current = false;
      initialDataPromiseRef.current = null;
      throw error;
    }
  };

  const fetchTransferStation = async (initialDataParam = null) => {
    try {
      // Use passed data, stored data, or fetch it
      let initialData = null;
      if (initialDataParam) {
        // Use data passed as parameter (prevents duplicate calls)
        initialData = initialDataParam;
      } else if (isInitialDataLoaded && allZonesData.length > 0) {
        // Use stored data if available
        initialData = {
          zones: allZonesData,
          circles: allCirclesData,
          wards: allWardsData,
        };
      } else {
        // Only fetch if data is not available
        initialData = await fetchInitialData();
      }
      
      const transferStationResponse = await getAllTransferStationMaster();
      if (!transferStationResponse) {
        console.error(
          "Transfer station response is undefined:",
          transferStationResponse
        );
      }
      const transferStationData = transferStationResponse;
      // Use stored data instead of calling APIs again
      const zoneResponse = initialData.zones || [];
      const circleResponse = initialData.circles || [];
      const wardResponse = initialData.wards || [];
      
      const zoneNamesDictionary = {};
      zoneResponse.forEach((zone) => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName || "N/A";
      });
     const circleNamesDictionary = {};
      circleResponse.forEach((circle) => {
        circleNamesDictionary[circle.circleId] = circle.circleName || "N/A";
      });
      const wardNamesDictionary = {};
      wardResponse.forEach((ward) => {
        wardNamesDictionary[ward.wardId] = ward.wardName || "N/A";
      });
      // console.log(wardNamesDictionary, "warddata")
      // console.log(circleNamesDictionary, "circledata")
      // console.log(zoneNamesDictionary, 'zonedata')
      const mappedTransferStationData = transferStationData.map((station) => ({
        ...station,
        corporation: station.corporationName || "N/A",
        zone: zoneNamesDictionary[station.zoneId] || "N/A",
        circle: circleNamesDictionary[station.circleId] || "N/A",
        ward: wardNamesDictionary[station.wardId] || "N/A",
        transferStationAddress: station.transferStationLocation || "N/A",
        transferStationCode: station.transferStationCode || "N/A",
        transferStationCapacity:station.transferStationCapacity || "N/A",
        transferStation: station.transferStationName || "N/A", 
        status: station.isActive ? "Active" : "InActive",
      }));
      // Sort the data based on the isActive field
      const sortedRouteData = mappedTransferStationData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setTransferStationData(sortedRouteData);

      setTransferStationData(mappedTransferStationData);
      setIsOptionsLoading(false);
      setOriginalData(mappedTransferStationData);
      setFilterOriginalTransferStationData(mappedTransferStationData);
      return mappedTransferStationData;
    } catch (error) {
      console.error("Error fetching transfer station data:", error);
      throw error;
    }
  };

  const resetFields = (reset) => {
    setFormInput({
      transferStationName: "",
      transferStationCode: "",
      transferStationLocation: "",
      transferStationCapacity: "",
      numberOfContainers: "",
      approximateTravelTimeInMinutes: "",
      Remarks:"",
      radiusInMeters: "",
      longitude: "",
      latitude: "",
      corporationId: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      isActive: "",
      transferStationId: "",
    });
    resetRef.current();
  };

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedTransferStation(null);
    setSelectedImage(null);
    setImagePreview(null);
    setFormSubmitted(false);
  };

  const handleEditTransferStation = async (selectedTransferStationData) => {
    // console.log(selectedTransferStationData, "selectedTransferStationData");
    setEditTransferStationData(selectedTransferStationData);
    setEditTransferStationId(selectedTransferStationData.transferStationId);
    setSelectedTransferStation(selectedTransferStationData);
    setLgShow(true);
    setIsOptionsLoading(true);
    const { circleId, wardId, zoneId } = selectedTransferStationData;
    setFormInput({
      ...formInput,
      corporationId: selectedTransferStationData.corporationId || "",
      zoneId,
      circleId,
      wardId,
      transferStationName: selectedTransferStationData.transferStationName,
      transferStationCode: selectedTransferStationData.transferStationCode,
      transferStationLocation:
        selectedTransferStationData.transferStationLocation,
      transferStationCapacity:
        selectedTransferStationData.transferStationCapacity,
      numberOfContainers: selectedTransferStationData.numberOfContainers,
      approximateTravelTimeInMinutes:
        selectedTransferStationData.approximateTravelTimeInMinutes,
        Remarks:selectedTransferStationData.remarks,
      radiusInMeters: selectedTransferStationData.radiusInMeters,
      longitude: selectedTransferStationData.longitude,
      latitude: selectedTransferStationData.latitude,
      isActive: selectedTransferStationData.isActive,
      transferStationId: selectedTransferStationData.transferStationId,
    });
    try {
      const circlesData = await GetCirclebyID(
        selectedTransferStationData.zoneId
      );
      setCircles(circlesData);
      const wardsData = await GetWardsbyCircleId(
        selectedTransferStationData.circleId
      );
      setWards(wardsData);
    } catch (error) {
      console.error("Error fetching circles and wards data:", error);
    }
    reset();
    setIsOptionsLoading(false);
  };

  // console.log(formInput, 'formInput')

  const addNewTransferStation = async (data) => {
    try {
      setFormSubmitted(true);
      setIsOptionsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // const zoneId = data.zoneId || "";
      // const circleId = data.circleId || "";
      // const wardId = data.wardId || "";
      // const transferStationName = data.transferStationName || "";
      // const transferStationCode = data.transferStationCode || "";
      // const transferStationLocation = data.transferStationLocation || "";
      // const transferStationCapcity = data.transferStationCapcity || "";
      // const numberOfContainers = data.numberOfContainers || "";
      // const approximateTravelTimeInMinutes = data.approximateTravelTimeInMinutes || ""
      // const radiusInMeters = data.radiusInMeters || "";
      // const longitude = data.longitude || "";
      // const latitude = data.latitude || "";
      // // const isActive = data.isActive || true;
      // const isActive = data.isActive || '';
      // // const isActive = selectedTransferStation ? formInput.isActive : true;
      // const transferStationId = data.transferStationId || "";
      if (
        !formInput.zoneId ||
        !formInput.circleId ||
        // !formInput.wardId ||
        !formInput.transferStationName ||
        // !formInput.transferStationCode ||
        !formInput.transferStationLocation ||
        !formInput.transferStationCapacity ||
        // !formInput.numberOfContainers ||
        // !formInput.approximateTravelTimeInMinutes ||
        // !formInput.Remarks ||
        // !formInput.radiusInMeters ||
        !formInput.latitude ||
        !formInput.longitude
        // || !formInput.isActive
      ) {
        // // Display toast message indicating the required field
        // toast.error("Please fill out all required fields", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        // });
        return;
      }
      // new
      const {
        corporationId,
        zoneId,
        circleId,
        wardId,
        transferStationName,
        transferStationCode,
        transferStationLocation,
        transferStationCapacity,
        numberOfContainers,
        approximateTravelTimeInMinutes,
        Remarks,
        radiusInMeters,
        latitude,
        longitude,
        isActive,
        transferStationId,
      } = formInput;

      const requestData = {
        corporationId: corporationId ? Number(corporationId) : null,
        zoneId,
        circleId,
        wardId:wardId || null,
        transferStationName,
        transferStationCode,
        transferStationLocation,
        transferStationCapacity,
        numberOfContainers : numberOfContainers || null,
        approximateTravelTimeInMinutes:approximateTravelTimeInMinutes|| null,
        remarks:Remarks,
        radiusInMeters:radiusInMeters||null,
        latitude,
        longitude,
        isActive,
        transferStationId,
      };
      if (selectedTransferStation) {
        const res = await updateTransferStationMaster(
          selectedTransferStation.transferStationId,
          requestData
        );
        // console.log(res, "from update function");
        const successMessage = "Transfer Station Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchTransferStation();
        reset();
        handleClose();
      } else {
        const res = await createTransferStationMaster(requestData);
        // console.log(res, "res from add");
        const successMessage = "New Transfer Station Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        reset();
        fetchTransferStation();
        handleClose();
      }
    } catch (error) {
      // console.log("Error", error);
      // console.log("validation errors", error.response);
      // Object.values(error.response.data.errors).map((item) => {
      //   toast.error(item[0], {
      //     position: "top-right",
      //     autoClose: 3000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   })
      // })
      if (error.response) {
        console.log(error.response, "error.response");
        const { status, data } = error.response;
        if (status === 409) {
          const validationErrors = data.errors;
        } else if (status === 400) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewTransferStation);
    }
  };

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "",
      wardId: "",
    }));
    setSelectedCircles("");
    if (zoneId) {
      try {
        const circlesData = await GetCirclebyID(zoneId);
        // console.log(circlesData,'circle data');
        setCircles(circlesData);
      } catch (error) {
        console.error("Error fetching circles data:", error);
      }
    } else {
      setCircles([]);
    }
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "",
    }));
    setSelectedWard("");
    if (circleId) {
      try {
        const wardsData = await GetWardsbyCircleId(circleId);
        setWards(wardsData);
      } catch (error) {
        console.error("Error fetching wards data:", error);
      }
    } else {
      setWards([]);
    }
  };

  const fetchCirclesAndWards = async (zoneId) => {
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setCircles(circlesData);
      setSelectedCircles([]);
      setCircleFetchError(null);
      setNoCircles(false);
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircleFetchError("Error fetching circles data");
      setCircles([]);
      setNoCircles(false);
      setWards([]);
    }
  };



  useEffect(() => {
    const initializeData = async () => {
      const initialData = await fetchInitialData();
      // Use the data directly instead of calling fetchInitialData again
      const zonesData = initialData.zones || [];
      const zoneTrueValues = zonesData.filter(
        (item) => item.isActive === true
      );
      setAllZones(zoneTrueValues);
      
      // Pass the data directly to prevent duplicate API calls
      fetchTransferStation(initialData);
      if (editTransferStationId) {
        fetchCirclesAndWards(editTransferStationData.zoneId);
        setSelectedTransferStationCoordinates({
          lat: parseFloat(editTransferStationData.latitude),
          lng: parseFloat(editTransferStationData.longitude),
        });
      }
    };
    initializeData();
  }, []);

  // map
  // const handleMapClick = (e) => {
  //   const lat = e.latlng.lat;
  //   const lng = e.latlng.lng;
  //   // Update the selected transferStation coordinates
  //   setSelectedTransferStationCoordinates({ lat, lng });
  //   setFormInput({ ...formInput, latitude: lat, longitude: lng });
  //   // Update the form input values
  //   setValue("latitude", lat);
  //   setValue("longitude", lng);
  // };

  const handleMapClick = (e) => {
    const { lat, lng } = e.latlng;
    setSelectedTransferStationCoordinates({ lat, lng });
    setFormInput({ ...formInput, latitude: lat, longitude: lng });
  };

  const MapEvents = () => {
    useMapEvents({
      click: handleMapClick,
    });
    return null;
  };
  const handleMapChange = (e) => {
    const { name, value } = e.target;
  
    // Regular expression to check for valid number (allowing only digits and one decimal point)
    const validNumberRegex = /^-?\d*\.?\d*$/;
  
    // Check if the value is a valid number or empty
    if (validNumberRegex.test(value) || value === "") {
      setFormInput({ ...formInput, [name]: value });
      setValue(name, value, { shouldValidate: true });
  
      if (name === "latitude" || name === "longitude") {
        const lat =
          name === "latitude" && value !== "" ? parseFloat(value) : formInput.latitude;
        const lng =
          name === "longitude" && value !== "" ? parseFloat(value) : formInput.longitude;
  
        if (value === "") {
          setSelectedTransferStationCoordinates({ lat: "", lng: "" }); // Reset when empty
        } else if (!isNaN(lat) && !isNaN(lng)) {
          setSelectedTransferStationCoordinates({ lat, lng });
        }
      }
    }
  };

  const validateLatitudeRequired = (value) => {
    if (!value || value === "") {
      return "Latitude is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue) || !value.includes(".")) {
      return "Latitude must contain a decimal value";
    }
    if (numValue < -90.0 || numValue > 90.0) {
      return "Latitude must be between -90.0 and 90.0";
    }
    return true;
  };
  
  const validateLongitudeRequired = (value) => {
    if (!value || value === "") {
      return "Longitude is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue) || !value.includes(".")) {
      return "Longitude must contain a decimal value";
    }
    if (numValue < -180.0 || numValue > 180.0) {
      return "Longitude must be between -180.0 and 180.0";
    }
    return true;
  };
  
  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "activeRadio" ? 1 : 2;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true",
      // [name]: value === "true" ? true : false,
    }));
  };

  const handleViewTransferStationData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsOptionsLoading(true);
      const response = await getTransferStationById(id);
      const transferStationDetails = response.data.data;
      // console.log(response.data.data, 'responseID')
      navigate("/transfer-station-details", {
        state: { transferStationDetails },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormInput({
      transferStationName: "",
      transferStationCode: "",
      transferStationLocation: "",
      transferStationCapacity: "",
      numberOfContainers: "",
      approximateTravelTimeInMinutes: "",
      // Remarks:"",
      radiusInMeters: "",
      longitude: 78.3599819,
      latitude: 17.452555,
      zoneId: "",
      circleId: "",
      wardId: "",
      isActive: true,
      transferStationId: "",
    });
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };

  const customMarkerIcon = L.icon({
    iconUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAw8Jfpzq4fp1vFbIILJHCdRI1WKWxMJatng&usqp=CAU",
    iconSize: [30, 30], // Adjust the size as needed
  });

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;
    const downloadAsExcel = async () => {
      // Create a new workbook and add a worksheet
      const dataToUse = sortedData.length > 0 ? sortedData : originalData;
      const currentDate = new Date();
      const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
      const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      const cumulativeHeadingReport = `Transfer Station Details`;
      const downloadDateTime = `Transfer Station Report Generated on: ${generationTime}, ${formattedTime}`;
      
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Zones");
    
      // Define styles
      const boldFont = { bold: true };
    
      // Add the downloadDateTime to the correct row and columns, and ensure formatting
      worksheet.addRow(["", "", downloadDateTime, ""]);
      worksheet.mergeCells(1, 2, 1, 10); // Merge cells for downloadDateTime from column 2 to 4
      worksheet.getCell(1, 2).value = downloadDateTime;
      worksheet.getCell(1, 2).font = boldFont; // Set font style
      worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
    
      // Add "Transfer Station Details" to the correct row and columns, and ensure formatting
      worksheet.addRow(["", "", "Transfer Station Details", ""]);
      worksheet.mergeCells(2, 2, 2, 10); // Merge cells for "Transfer Station Details"
      worksheet.getCell(2, 2).value = "Transfer Station Details";
      worksheet.getCell(2, 2).font = boldFont;
      worksheet.getCell(2, 2).alignment = { horizontal: "center" };
    
      // Add an empty row for spacing
      worksheet.addRow([""]);
    
      // Add table header row with bold font
      const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Transfer Station Code",
        "Transfer Station",
        "Transfer Station Address",
        "Transfer Station Capacity",
        "Corporation",
        "Zone",
        "Circle",
        "Ward",
        "Latitude",
        "Longitude",
        "Status",
      ]);
    
      // Apply bold font and background color to header row
      tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left-align the cell content
        if (colNumber >= 1 && colNumber <= 12) {
          // Apply background color only to specific cells
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F6B1B1" }, // Red background color
          };
        }
      });
      
      // Add data rows
      dataToUse.forEach((item, index) => {
        worksheet
          .addRow([
            index + 1,
            item.transferStationCode,
            item.transferStation,
            item.transferStationAddress,
            item.transferStationCapacity,
            item.corporation,
            item.zone,
            item.circle,
            item.ward,
            item.latitude+"",
            item.longitude+"",
            item.status,
          ])
          .eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 11) {
              // Align the columns from 1 to 11 to the left
              cell.alignment = { horizontal: "left" };
            } else {
              // Align the rest of the columns to the center
              cell.alignment = { horizontal: "center" };
            }

            // Ensure Latitude and Longitude are displayed as text (no formatting applied)
            if (colNumber === 10 || colNumber === 11) {
              cell.numFmt = '@'; // Treat as text (ensures the full value is displayed as entered)
            }
          });
      });
    
      // Auto-resize columns for specific columns (e.g., 'Transfer Station Address', 'Latitude', 'Longitude')
      const columnsToResize = [4, 10, 11]; // Columns we want to resize (1-indexed, so 4 = 'Transfer Station Address', 10 = 'Latitude', 11 = 'Longitude')

      columnsToResize.forEach((colIndex) => {
        let maxLength = 0;
        worksheet.getColumn(colIndex).eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = (cell.value ? String(cell.value) : "").length;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        // Set column width based on the maximum content length, adding some padding (e.g., +5 for some buffer space)
        worksheet.getColumn(colIndex).width = maxLength + 5;
      });

      // Set fixed widths for other columns
      worksheet.getColumn(1).width = 5; // S.No column
      worksheet.getColumn(2).width = 20; // Transfer Station Code column
      worksheet.getColumn(3).width = 28; // Transfer Station column
      worksheet.getColumn(5).width = 25; // Transfer Station Capacity column
      worksheet.getColumn(6).width = 25; // Corporation column
      worksheet.getColumn(7).width = 15; // Zone column
      worksheet.getColumn(8).width = 15; // Circle column
      worksheet.getColumn(9).width = 15; // Ward column
      worksheet.getColumn(10).width = 20; // Latitude column
      worksheet.getColumn(11).width = 20; // Longitude column
      worksheet.getColumn(12).width = 15; // Status column
    
      // Save the workbook to a file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TransferStationDetails.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    };
    
    

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 12;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(
      `canWrite value for permission ID ${storedPermissions}:`,
      canWriteValue
    );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...transferStationData].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  // const SearchControl = () => {
  //   const map = useMap();

  //   useEffect(() => {
  //     const provider = new OpenStreetMapProvider();
  //     const searchControl = new GeoSearchControl({
  //       provider: provider,
  //       // style: 'bar',
  //       showMarker: false,
  //       retainZoomLevel: true,
  //       animateZoom: true,
  //       autoClose: true,
  //       searchLabel: "search",
  //       keepResult: true,
  //     });

  //     map.addControl(searchControl);

  //     map.on("geosearch/showlocation", (e) => {
  //       const { location } = e;

  //       if (location && location.x && location.y) {
  //         // Ensure location has valid coordinates
  //         const { x, y } = location;
  //         setSelectedTransferStationCoordinates({ lat: y, lng: x });
  //         map.setView([y, x], 13);
  //       }
  //     });

  //     return () => {
  //       map.removeControl(searchControl);
  //     };
  //   }, [map]);

  //   return null; 
  // };

  const searchTransferStationHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalTransferStationData.filter(
      (item) =>
        item?.transferStationName?.toLowerCase()?.includes(term) ||
        item?.transferStationCode?.toLowerCase()?.includes(term)
    );
    setTransferStationData(data);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Transfer Station or Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchTransferStationHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end mb-3">
                    {canWriteValue === true ? (
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("Add Transfer Station")}
                      </button>
                    ) : (
                      ""
                    )}
                    <button
                      className="btn btn-excel"
                      onClick={handleSortAndExport}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>{t("Transfer Station Details")} </span>
                  </div>
                    {isOptionsLoading?<TableSkeleton />: <TableComponent
                    DataFetchURL={transferStationData}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 0
                      )
                    }
                    editData={handleEditTransferStation}
                    editTransferStationData={editTransferStationData}
                    viewData={(id) => handleViewTransferStationData(id)}
                    onSort={handleSort}
                    skipGetCircle={true}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedTransferStation
              ? "Edit Transfer Station"
              : "Add Transfer Station"}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewTransferStation)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/* {selectedTransferStation ? ( */}
              <div className="col-md-4 " style={{ display: "none" }}>
                <div className="form-group">
                  <label className="form-label">ID</label>
                  <input
                    type="number"
                    className="form-control"
                    name="transferStationId"
                    {...register("transferStationId")}
                    value={formInput.transferStationId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationId: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              {/* <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station Code{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter TransferStation Code"
                    className={`form-control ${
                      formInput.transferStationCode || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="transferStationCode"
                    {...register("transferStationCode")}
                    value={formInput.transferStationCode}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(
                        /[^a-zA-Z0-9]/g,
                        ""
                      );
                      setFormInput({
                        ...formInput,
                        transferStationCode: sanitizedValue,
                      });
                    }}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.transferStationCode && formSubmitted && (
                    <div className="required-message">
                      Transfer Station Code is Required
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter TransferStation Name"
                    className={`form-control ${
                      formInput.transferStationName || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="transferStationName"
                    {...register("transferStationName")}
                    value={formInput.transferStationName}
                    onChange={(e) =>{
                      let sanitizedValue = e.target.value
                      
                      .slice(0, 42) // Limit to 42 characters
                      .replace(/^\s+/, "") // Remove leading spaces
                      .replace(/\s{2,}/g, " ")
                      .replace(/[^A-Za-z0-9\s-]/g, "")
                      setFormInput({
                        ...formInput,
                        transferStationName: sanitizedValue,
                      })
                    }}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.transferStationName && formSubmitted && (
                    <div className="required-message">
                      Transfer Station is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station Address{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter TransferStation Address"
                    className={`form-control ${
                      formInput.transferStationLocation || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="transferStationLocation"
                    {...register("transferStationLocation")}
                    value={formInput.transferStationLocation}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationLocation: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                    maxLength={100}
                  />
                  {!formInput.transferStationLocation && formSubmitted && (
                    <div className="required-message">
                      Transfer Station Address is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station Capacity{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter TransferStation Capacity"
                    className={`form-control ${
                      formInput.transferStationCapacity || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="transferStationCapacity"
                    {...register("transferStationCapacity")}
                    value={formInput.transferStationCapacity}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationCapacity: e.target.value,
                      })
                    }
                    onInput={(e) => {
                      handleAlphaNumeric(e);
                    }}
                  
                    maxLength={20}
                    disabled={!canWriteValue}
                  />
                  {!formInput.transferStationCapacity && formSubmitted && (
                    <div className="required-message">
                      Transfer Station Capacity is Required
                    </div>
                  )}
                </div>
              </div>

              

              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">No. Of Containers</label>
                  <input
                    type="number"
                    placeholder="Enter no of Containers"
                    className={`form-control ${
                      formInput.numberOfContainers || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="numberOfContainers"
                    {...register("numberOfContainers")}
                    value={formInput.numberOfContainers}
                    min={0}
                    onInput={(e) => {
                      const maxLength = 2;
                      if (e.target.value.length > maxLength) {
                        e.target.value = e.target.value.slice(0, maxLength);
                      }
                    }}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        numberOfContainers: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
                     
                     <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Corporation <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.corporationId}
                    {...register("corporationId")}
                    name="corporationId"
                    className={`form-select ${
                      formInput.corporationId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      setFormInput({
                        ...formInput,
                        corporationId: e.target.value,
                        zoneId: "",
                        circleId: "",
                        wardId: "",
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                   <option value="">Select Corporation</option>
                    {CorporationDetails.map((cd)=>{
                     return <option value={cd.corporationId}>{cd.corporationName}</option>
                    })}
                   
                   
                  </select>
                  {!formInput.corporationid && formSubmitted && (
                    <div className="required-message">Corporation is Required</div>
                  )}
                </div>
              </div>

              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Zone <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    {...register("zoneId")}
                    name="zoneId"
                    className={`form-select ${
                      formInput.zoneId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setSelectedZone(selectedZoneId);

                      // Check if the selected zone is different from the previously selected zone
                      if (selectedZoneId !== selectedZone) {
                        // Fetch circles and wards only if the zone is different
                        fetchCirclesAndWards(selectedZoneId);
                      }
                      // Update formInput with the selected zoneId
                      setFormInput({
                        ...formInput,
                        zoneId: selectedZoneId,
                        circleId: "", // Reset circleId when zone changes
                        wardId: "", // Reset wardId when zone changes
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {allZones?.filter(zone => !formInput.corporationId || String(zone.corporationId) === String(formInput.corporationId)).map((zone) => (
                      <option key={zone.zoneId} value={zone.zoneId}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message">Zone is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Circle <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.circleId}
                    placeholder="Enter Circle"
                    name="circleId"
                    className={`form-select ${
                      formInput.circleId || !formSubmitted ? "" : "input-error"
                    }`}
                    {...register("circleId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                      }));
                      handleCircleChange(e.target.value);
                    }}
                    disabled={!formInput.zoneId}
                    readOnly={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {loadingCircles && (
                      <option disabled>Loading circles...</option>
                    )}
                    {Array.isArray(circles) && circles.length > 0 ? (
                      circles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message">Circle is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Ward 
                  </label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className={`form-select ${
                      formInput.wardId || !formSubmitted ? "" : "input-error"
                    }`}
                    {...register("wardId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }));
                    }}
                    disabled={!formInput.circleId}
                    readOnly={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {loadingWards && <option disabled>Loading Wards...</option>}
                    {Array.isArray(wards) &&
                      wards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Latitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="latitude"
                    value={formInput.latitude || selectedTransferStationCoordinates.lat}
                    {...register("latitude", {
                      required: "Latitude is Required",
                      validate: validateLatitudeRequired, // Custom validation for latitude
                    })}
                    onChange={handleMapChange}
                    disabled={!canWriteValue}
                  />
                  {errors.latitude && (
                    <div className="required-message">{errors.latitude.message}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Longitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="longitude"
                    value={formInput.longitude || selectedTransferStationCoordinates.lng}
                    {...register("longitude", {
                      required: "Longitude is Required",
                      validate: validateLongitudeRequired, // Custom validation for longitude
                    })}
                    onChange={handleMapChange}
                    disabled={!canWriteValue}
                  />
                  {errors.longitude && (
                    <div className="required-message">{errors.longitude.message}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Radius In Meters{" "}
                  </label>
                  <input
                    type="number"
                    placeholder="Enter Radius in Meters"
                    className={`form-control ${
                      formInput.radiusInMeters || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    min={0}
                    name="radiusInMeters"
                    {...register("radiusInMeters")}
                    value={formInput.radiusInMeters}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || (value.length <= 6 && /^\d*$/.test(value))) {
                        setFormInput({
                          ...formInput,
                          radiusInMeters: value,
                        });
                      }
                    }}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Approximate Travel Time In Minutes
                  </label>
                  <input
                    type="number"
                    placeholder="Enter Travel Time In minutes"
                    className={`form-control ${
                      formInput.approximateTravelTimeInMinutes || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="approximateTravelTimeInMinutes"
                    {...register("approximateTravelTimeInMinutes")}
                    value={formInput.approximateTravelTimeInMinutes}
                    min={0}
                    onInput={(e) => {
                      const maxLength = 4;
                      if (e.target.value.length > maxLength) {
                        e.target.value = e.target.value.slice(0, maxLength);
                      }
                    }}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        approximateTravelTimeInMinutes: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
               
              </div>
             
              {/* {selectedTransferStation ? ( */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Status <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <div className="d-flex">
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="isActive"
                        id="activeRadio"
                        {...register("isActive")}
                        value="true"
                        checked={formInput.isActive === true}
                        onChange={() =>
                          setFormInput({ ...formInput, isActive: true })
                        }
                        // onChange={handleStatusChange}
                      />
                      <label className="form-check-label" htmlFor="activeRadio">
                        Active
                      </label>
                    </div>
                    <div className="form-check" style={{ marginLeft: "60px" }}>
                      <input
                        type="radio"
                        className="form-check-input"
                        name="isActive"
                        id="inactiveRadio"
                        {...register("isActive")}
                        value="false"
                        checked={formInput.isActive === false}
                        onChange={() =>
                          setFormInput({ ...formInput, isActive: false })
                        }
                        // onChange={handleStatusChange}
                      />
                      <label className="form-check-label" htmlFor="inactiveRadio">
                        InActive
                      </label>
                    </div>
                    </div>
                </div>
              </div>
              <div className="col-md-8 mb-3">
                  <div
                    className="form-group"
                    style={{ display: "flex", flexDirection: "column",width:"100%" }}
                  >
                    <label className="form-label">{t("Remarks")}</label>
                    <textarea
                    style={{minHeight:"60px"}}
                      type="text"
                      name="remark"
                      value={formInput.Remarks}
                      rows={1}
                      maxLength={500}
                      // className={`form-control ${
                      //   formInput.remark || !formSubmitted ? "" : "input-error"
                      // }`}
                      // className="form-control"
                      // placeholder="Enter Vehicle UUID"
                      onChange={(e) =>
                        setFormInput({
                          ...formInput,
                          Remarks: e.target.value,
                        })
                      }
                      disabled={!canWriteValue}
                    />
                    {/* {!formInput.remark && formSubmitted && (
                    <div className="required-message">Required.</div>
                  )} */}
                  </div>
                </div>
              {/* ) : (
                ""
              )} */}
              {/* <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">File <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="file"
                    className="form-control"
                    name="file"
                    {...register("file")}
                    // value={formInput.file}
                    onChange={(e) => {
                      setFormInput({ ...formInput, file: e.target.value[0] });
                      handleImageChange(e);
                    }}
                  />
                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="Selected"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </div>
              </div> */}
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label">Map</label>
                  {/* <LoadScript
                    googleMapsApiKey="AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw"
                    onError={(error) =>
                      console.error("Error loading Google Maps:", error)
                    }
                  > */}
                  <MapContainer
                    center={selectedTransferStationCoordinates}
                    zoom={14}
                    style={{ height: "400px", width: "100%" }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {/* <SearchControl /> */}
                    <Marker
                      position={selectedTransferStationCoordinates}
                      icon={customMarkerIcon}
                    />
                    <Circle
                      center={selectedTransferStationCoordinates}
                      pathOptions={{
                        color: "red",
                        fillColor: "#f03",
                        fillOpacity: 0.5,
                      }}
                      radius={200}
                    />
                    <MapEvents />
                  </MapContainer>
                  {/* </LoadScript> */}
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ? (
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedTransferStation ? t("Update") : t("Save")}
                </button>
              ) : (
                ""
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(TransferStationMaster);
